import { render, staticRenderFns } from "./RafterPrintPage.vue?vue&type=template&id=0820d6db"
import script from "./RafterPrintPage.vue?vue&type=script&lang=js"
export * from "./RafterPrintPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports